module.exports = __webpack_public_path__ + "static/herovideo-b322e5d8e48d8ed8d775be19d46bbc08.mp4";